module.exports = __webpack_public_path__ + "img/home_menu_14_selected.657cac10.png";